'use es6';

import SeamlessImmutable from 'seamless-immutable';
/**
 * Required props:
 *  - assetId
 */

const getPublishes = (state, props) => SeamlessImmutable.getIn(state, ['session', 'publishes', 'byId', props.assetId], null);
/**
 * Required props:
 *  - assetId
 */


export const getLastPublishedAt = (state, props) => {
  const publishes = getPublishes(state, props);
  return publishes ? publishes.lastPublishedAt : null;
};